import Dashboard from "../dashboard/Dashboard";
import Card from "../../components/cards/Card";
import { NavLink, useLocation } from "react-router-dom";
import ReviewSummaryCard from "./review.summary.card";
import { useEffect, useState } from "react";
import { getRequest } from "../../services/api.service";
import { API_URL } from "../../utils/constants";
import { ICommon } from "./types";
import showToast from "../../utils/show.toast";

type ReviewTotalCounts = {
  approved?: number;
  pending?: number;
  rejected?: number;
};

interface ReviewResponse extends ICommon {
  result: {
    languageToTeach: number;
    languageSpoken: number;
    workExperience: number;
    education: number;
    certification: number;
    introductoryVideo: number;
    total: number;
  };
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Reviews() {
  const [counts, setCounts] = useState({
    education: 0,
    certification: 0,
    workExperience: 0,
    languageToTeach: 0,
    languageSpoken: 0,
    introductoryVideo: 0,
  });

  const [reviewsTotal, setReviewsTotal] = useState<ReviewTotalCounts>({
    pending: 0,
    approved: 0,
    rejected: 0,
  });

  const query = useQuery();
  const status = query.get("status");

  useEffect(() => {
    Promise.all([
      getRequest<ReviewResponse>(
        `${API_URL}/teachers/update-requests/count-by-status?status=PENDING`
      ),
      getRequest<ReviewResponse>(
        `${API_URL}/teachers/update-requests/count-by-status?status=APPROVED`
      ),
      getRequest<ReviewResponse>(
        `${API_URL}/teachers/update-requests/count-by-status?status=REJECTED`
      ),
    ])
      .then(([pendingData, approvedData, rejectedData]) => {
        const counts: ReviewTotalCounts = {
          pending: pendingData?.result.total,
          approved: approvedData?.result.total,
          rejected: rejectedData?.result.total,
        };

        console.log("Counts:", counts);

        return setReviewsTotal(counts);
      })
      .catch((error) => {
        const message =
          error instanceof Error
            ? error.message
            : "Error fetching review counts";
        showToast(message, false);
      });
  }, []);

  const fetchCount = async () => {
    try {
      const response = await getRequest<ReviewResponse>(
        `${API_URL}/teachers/update-requests/count-by-status?status=${status}`
      );

      if (response.status !== "success") {
        showToast(
          "Please try agin later. There was an errror fetching reviews.",
          false
        );
        return;
      }
      setCounts(response.result);
    } catch (error) {
      showToast("There was an error fetching reviews stat", false);
      return;
    }
  };

  useEffect(() => {
    fetchCount();
  }, [status]);

  return (
    <>
      <Dashboard
        pageTitle={`${status} REVIEWS`}
        subChildren={
          <ReviewSummaryCard
            statusCounter={{
              pending: reviewsTotal?.pending || 0,
              approved: reviewsTotal?.approved || 0,
              rejected: reviewsTotal?.rejected || 0,
            }}
            status={status as string}
          />
        }
      >
        <section className="card-container">
          <NavLink
            to={`/review/language-to-teach/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card title="Languages to Teach" number={counts.languageToTeach} />
          </NavLink>

          <NavLink
            to={`/review/work-experience/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card title="Work Experience" number={counts.workExperience} />
          </NavLink>

          <NavLink
            to={`/review/language-spoken/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card title="Languages to Speak" number={counts.languageSpoken} />
          </NavLink>

          <NavLink
            to={`/review/education/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card title="Education" number={counts.education} />
          </NavLink>

          <NavLink
            to={`/review/certification/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card title="Certification" number={counts.certification} />
          </NavLink>

          <NavLink
            to={`/review/introductory/list?status=${status?.toLocaleLowerCase()}`}
          >
            <Card
              title="Introductory Video"
              number={counts.introductoryVideo}
            />
          </NavLink>
        </section>
      </Dashboard>
    </>
  );
}
